import ApiClient from 'api-client/ApiClient'

const { keystone } = ApiClient.getInstance()

export const getGroupUsers = async (groupId) => keystone.getGroupUsers({ groupId })
